'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.api').config(translationsConfig);

    function translationsConfig($translateProvider) {
        'ngInject';

        $translateProvider.translations('el', {
            'api': {
                'Api': 'Προγραμματιστικές διεπαφές',
                'Open data middleware API': 'Προγραμματιστικές διεπαφές Δεδομένων διαδικτύου των αντικειμένων',
                'Datasets API': 'Προγραμματιστικές διεπαφές Συνόλων δεδομένων'
            }
        });
    }
})();